export const sifUrl = (domain: string, pdfPath: string): string =>
  `${domain}/${pdfPath.split("/").map(encodeURIComponent).join("/")}`;
